// src/components/AIMito/ChatInput.tsx
import React, { FC, useState } from 'react';
import SendButton from 'Components/Buttons/SendButton';
import UploadDocumentButton from 'Components/Buttons/UploadDocumentButton';

interface ChatInputProps {
  sendMessage: (question: string) => void;
  loading: boolean;
}

const ChatInput: FC<ChatInputProps> = ({ sendMessage, loading }) => {
  const [question, setQuestion] = useState('');

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && !loading) {
      sendMessage(question);
      setQuestion('');
    }
  };

  const handleFileUpload = (files: File[]) => {
    console.log('Uploaded files:', files);
    // Add your upload logic here if needed
  };

  // We override the default mobile media query by using inline
  // style { flexDirection: 'row', flexWrap: 'nowrap' } to ensure
  // everything stays on the same row, even on small screens.
  return (
    <div
      className="chat-input flex items-center w-full overflow-x-auto"
      style={{ flexDirection: 'row', flexWrap: 'nowrap' }}
    >
      <input
        type="text"
        id="question"
        value={question}
        onChange={(e) => setQuestion(e.target.value)}
        placeholder="Ask your question here..."
        autoComplete="off"
        onKeyDown={handleKeyDown}
        disabled={loading}
        className="flex-grow min-w-0"
      />

      <div className="flex items-center space-x-2 flex-shrink-0">
        {/* <UploadDocumentButton onChange={handleFileUpload} disabled={loading} /> */}

        <SendButton
          onClick={() => {
            sendMessage(question);
            setQuestion('');
          }}
          disabled={loading}
          isLoading={loading}
        />
      </div>
    </div>
  );
};

export default ChatInput;
